module.exports = __webpack_public_path__ + "static/media/1012715.1e71863d.jpg";